import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__button_mjs_d80dd9e7__ from "../button.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__ from "../combobox.mjs";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__core_filter_operators_mjs_3caa67c3__ from "../../core/filter-operators.mjs";
function FilterOperator({ field, filter, actions }) {
    const [open, setOpen] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    const close = ()=>setOpen(false);
    const triggerValueFieldAction = __WEBPACK_EXTERNAL_MODULE_react__["default"].useCallback((operatorValue)=>{
        if (!(0, __WEBPACK_EXTERNAL_MODULE__core_filter_operators_mjs_3caa67c3__.operatorRequiresValue)(operatorValue)) return;
        setTimeout(()=>{
            const filterPill = document.querySelector(`[data-filter-id="${filter.id}"]`);
            const valueButton = filterPill?.querySelector("[data-filter-value-trigger]");
            if (valueButton) valueButton.click();
            else {
                const valueInput = filterPill?.querySelector("[data-filter-value-input]");
                valueInput?.focus();
            }
        }, 150);
    }, [
        filter.id
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.Combobox, {
        open: open,
        onOpenChange: setOpen,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxTrigger, {
                asChild: true,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_d80dd9e7__.Button, {
                    variant: "ghost",
                    className: "m-0 h-full w-fit active:scale-100 whitespace-nowrap font-normal hover:opacity-50 rounded-none p-0 px-2 text-[13px]",
                    "data-filter-operator-trigger": true,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FilterOperatorDisplay, {
                        filter: filter,
                        fieldType: field.type
                    })
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxContent, {
                align: "start",
                className: "w-fit p-0",
                loop: true,
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxInput, {
                        placeholder: "Search operators..."
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxEmpty, {
                        children: "No results"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxList, {
                        className: "max-h-fit",
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FilterOperatorController, {
                            filter: filter,
                            field: field,
                            actions: actions,
                            closeController: close,
                            triggerValueFieldAction: triggerValueFieldAction
                        })
                    })
                ]
            })
        ]
    });
}
function FilterOperatorDisplay({ filter, fieldType }) {
    if (!filter.operator) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
        className: "text-muted-foreground",
        children: "Select condition"
    });
    const operator = __WEBPACK_EXTERNAL_MODULE__core_filter_operators_mjs_3caa67c3__.fieldTypeOperatorDetails[fieldType][filter.operator];
    const label = (0, __WEBPACK_EXTERNAL_MODULE__core_filter_operators_mjs_3caa67c3__.formatOperatorLabel)(operator.key);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
        className: "text-secondary-foreground",
        children: label
    });
}
function FilterOperatorController({ filter, field, actions, closeController, triggerValueFieldAction }) {
    switch(field.type){
        case "select":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FilterOperatorSelectController, {
                filter: filter,
                field: field,
                actions: actions,
                closeController: closeController,
                triggerValueFieldAction: triggerValueFieldAction
            });
        case "input-select":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FilterOperatorInputSelectController, {
                filter: filter,
                field: field,
                actions: actions,
                closeController: closeController,
                triggerValueFieldAction: triggerValueFieldAction
            });
        case "multiSelect":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FilterOperatorMultiSelectController, {
                filter: filter,
                field: field,
                actions: actions,
                closeController: closeController,
                triggerValueFieldAction: triggerValueFieldAction
            });
        case "date":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FilterOperatorDateController, {
                filter: filter,
                field: field,
                actions: actions,
                closeController: closeController,
                triggerValueFieldAction: triggerValueFieldAction
            });
        case "text":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FilterOperatorTextController, {
                filter: filter,
                field: field,
                actions: actions,
                closeController: closeController,
                triggerValueFieldAction: triggerValueFieldAction
            });
        case "number":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FilterOperatorNumberController, {
                filter: filter,
                field: field,
                actions: actions,
                closeController: closeController,
                triggerValueFieldAction: triggerValueFieldAction
            });
        default:
            return null;
    }
}
function FilterOperatorSelectController({ filter, field, actions, closeController, triggerValueFieldAction }) {
    const relatedFilters = Object.values(__WEBPACK_EXTERNAL_MODULE__core_filter_operators_mjs_3caa67c3__.fieldTypeOperatorDetails.select);
    const changeOperator = (value)=>{
        actions.setFilterOperator(filter.id, value);
        closeController();
        triggerValueFieldAction(value);
    };
    return relatedFilters.map((r)=>{
        const label = (0, __WEBPACK_EXTERNAL_MODULE__core_filter_operators_mjs_3caa67c3__.formatOperatorLabel)(r.key);
        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxItem, {
            onSelect: changeOperator,
            value: r.value,
            children: label
        }, r.value);
    });
}
function FilterOperatorInputSelectController({ filter, field, actions, closeController, triggerValueFieldAction }) {
    const relatedFilters = Object.values(__WEBPACK_EXTERNAL_MODULE__core_filter_operators_mjs_3caa67c3__.fieldTypeOperatorDetails["input-select"]);
    const changeOperator = (value)=>{
        actions.setFilterOperator(filter.id, value);
        closeController();
        triggerValueFieldAction(value);
    };
    return relatedFilters.map((r)=>{
        const label = (0, __WEBPACK_EXTERNAL_MODULE__core_filter_operators_mjs_3caa67c3__.formatOperatorLabel)(r.key);
        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxItem, {
            onSelect: changeOperator,
            value: r.value,
            children: label
        }, r.value);
    });
}
function FilterOperatorMultiSelectController({ filter, field, actions, closeController, triggerValueFieldAction }) {
    const relatedFilters = Object.values(__WEBPACK_EXTERNAL_MODULE__core_filter_operators_mjs_3caa67c3__.fieldTypeOperatorDetails.multiSelect);
    const changeOperator = (value)=>{
        actions.setFilterOperator(filter.id, value);
        closeController();
        triggerValueFieldAction(value);
    };
    return relatedFilters.map((r)=>{
        const label = (0, __WEBPACK_EXTERNAL_MODULE__core_filter_operators_mjs_3caa67c3__.formatOperatorLabel)(r.key);
        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxItem, {
            onSelect: changeOperator,
            value: r.value,
            children: label
        }, r.value);
    });
}
function FilterOperatorDateController({ filter, field, actions, closeController, triggerValueFieldAction }) {
    const relatedFilters = Object.values(__WEBPACK_EXTERNAL_MODULE__core_filter_operators_mjs_3caa67c3__.fieldTypeOperatorDetails.date);
    const changeOperator = (value)=>{
        actions.setFilterOperator(filter.id, value);
        closeController();
        triggerValueFieldAction(value);
    };
    return relatedFilters.map((r)=>{
        const label = (0, __WEBPACK_EXTERNAL_MODULE__core_filter_operators_mjs_3caa67c3__.formatOperatorLabel)(r.key);
        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxItem, {
            onSelect: changeOperator,
            value: r.value,
            children: label
        }, r.value);
    });
}
function FilterOperatorTextController({ filter, field, actions, closeController, triggerValueFieldAction }) {
    const relatedFilters = Object.values(__WEBPACK_EXTERNAL_MODULE__core_filter_operators_mjs_3caa67c3__.fieldTypeOperatorDetails.text);
    const changeOperator = (value)=>{
        actions.setFilterOperator(filter.id, value);
        closeController();
        triggerValueFieldAction(value);
    };
    return relatedFilters.map((r)=>{
        const label = (0, __WEBPACK_EXTERNAL_MODULE__core_filter_operators_mjs_3caa67c3__.formatOperatorLabel)(r.key);
        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxItem, {
            onSelect: changeOperator,
            value: r.value,
            children: label
        }, r.value);
    });
}
function FilterOperatorNumberController({ filter, field, actions, closeController, triggerValueFieldAction }) {
    const relatedFilters = Object.values(__WEBPACK_EXTERNAL_MODULE__core_filter_operators_mjs_3caa67c3__.fieldTypeOperatorDetails.number);
    const changeOperator = (value)=>{
        actions.setFilterOperator(filter.id, value);
        closeController();
        triggerValueFieldAction(value);
    };
    return relatedFilters.map((r)=>{
        const label = (0, __WEBPACK_EXTERNAL_MODULE__core_filter_operators_mjs_3caa67c3__.formatOperatorLabel)(r.key);
        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxItem, {
            onSelect: ()=>changeOperator(r.value),
            value: r.value,
            children: label
        }, r.value);
    });
}
export { FilterOperator, FilterOperatorController, FilterOperatorDisplay, FilterOperatorTextController };
